import * as React from "react";
import { Tab, Box, Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import clsx from "clsx";

interface Props {
  TabNames: string[];
  TabContent: React.ReactNode[];
}

const useStyles = makeStyles((theme: Theme) => ({
  tabPanel: {
    "marginBottom": "1rem",
    "& .MuiTabs-root, & .MuiTabs-flexContainer, & .MuiTab-root": {
      maxHeight: 32,
      minHeight: 32,
    },
    "& .MuiTabPanel-root": {
      backgroundColor: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.secondary.dark}`,
      borderRadius: 5,
      borderTopLeftRadius: 0,
      marginTop: -1,
    },
  },
  tabHeader: {
    "& .MuiTab-root": {
      height: 32,
      minHeight: 32,
    },
    "backgroundColor": theme.palette.secondary.main,
    "border": `1px solid ${theme.palette.secondary.dark}`,
    "borderBottomColor": theme.palette.secondary.main,
    "borderTopLeftRadius": 5,
    "borderTopRightRadius": 5,
    "zIndex": 1,
    "& span": {
      color: theme.palette.primary.main,
      textTransform: "initial",
    },
  },
}));

export default function BasicTabs({ TabNames, TabContent }: Props) {
  const classes = useStyles();
  const [tab, setTab] = React.useState(0);

  const handleTabChange = (_event: any, newValue: number) => {
    setTab(newValue);
  };

  const tabList = TabNames.map((name: string, index: number) => {
    return (
      <Tab
        key={index}
        style={{
          width: `${100 / TabNames.length}%`,
          maxWidth: "50%",
        }}
        className={clsx(classes.tabHeader, `tab-${index}`)}
        label={name}
        value={index.toString()}
      />
    );
  });

  const tabContent = TabContent.map(
    (content: React.ReactNode, index: number) => {
      return (
        <TabPanel
          className={`tab-${index}`}
          key={index}
          value={index.toString()}
        >
          {content}
        </TabPanel>
      );
    },
  );
  return (
    <Box className={classes.tabPanel}>
      <TabContext value={tab.toString()}>
        <Box>
          <TabList onChange={handleTabChange} aria-label={"basic-tabs"}>
            {tabList}
          </TabList>
        </Box>
        {tabContent}
      </TabContext>
    </Box>
  );
}
